<template>
  <div>
    <!-- <div class="adabundle-subheader"><h4>Visually Pleasing Experience</h4></div> -->

    <div id="adabundle-visually-pleasing-experience-box">

        <div v-for="pleasing_experience in visually_pleasing_experience" v-show="pleasing_experience.status == 1" :id="pleasing_experience.id" class="adabundle-action-box adabundle-toggle-box" tabindex="0">
            <div class="adabundle-action-box-content">
                <span class="adabundle-icon"></span>
                <span class="adabundle-title">{{pleasing_experience.title}}</span>
            </div>
        </div>
      
        <div v-for="pleasing_experience_color in visually_pleasing_experience_colors" v-show="pleasing_experience_color.status == 1" :id="pleasing_experience_color.id" class="adabundle-action-box adabundle-palette-box">
            <div class="adabundle-action-box-content">
                <span class="adabundle-title">{{pleasing_experience_color.title}}</span>
                <div class="adabundle-color-box">
                    <span v-for="scheme in colors" :data-color="scheme.color" class="adabundle-color" role="button" tabindex="0" :aria-label="scheme.label" :style="'background-color: '+scheme.color+' !important;'"> </span>
                </div>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utility from '../common/Utility';
import  HTTP from "../common/Http";

export default {
  name: "VisuallyPleasingExperience",
  components: {
  },
  created () {
    this.init()
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWidgetOptions') {
        this.widgetOptions = state.widgetOptions;
        // this.init()
      }

      if (mutation.type === 'setWidgetLanguage') {
        this.init();
      }
    });
  },
  mounted(){
    this.logClicks();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  data () {
    return {
      isLoading: false,
      visually_pleasing_experience:[],
      visually_pleasing_experience_colors:[],
      colors:[
        {
            color: 'maroon',
            label: 'Change Color to Maroon',
        },
        {
            color: 'red',
            label: 'Change Color to Red',
        },
        {
            color: 'orange',
            label: 'Change Color to Orange',
        },
        {
            color: 'yellow',
            label: 'Change Color to Yellow',
        },
        {
            color: 'olive',
            label: 'Change Color to Olive',
        },
        {
            color: 'green',
            label: 'Change Color to Green',
        },
        {
            color: 'purple',
            label: 'Change Color to Purple',
        },
        {
            color: 'fuchsia',
            label: 'Change Color to Fuchsia',
        },
        {
            color: 'lime',
            label: 'Change Color to Lime',
        },
        {
            color: 'teal',
            label: 'Change Color to Teal',
        },
        {
            color: 'aqua',
            label: 'Change Color to Aqua',
        },
        {
            color: 'blue',
            label: 'Change Color to Blue',
        },
        {
            color: 'navy',
            label: 'Change Color to Navy',
        },
        {
            color: 'black',
            label: 'Change Color to Black',
        },
        {
            color: 'white',
            label: 'Change Color to White',
        },
      ] 
    }
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
      "t",
    ])
  },
  methods: {
    logClicks(){
      for(const button of this.visually_pleasing_experience){
        document.getElementById(button.id).addEventListener("click", (event) => {
            
            this.$store.dispatch('logClicks', { wid:this.wid, label: button.title, debug: this.debug});

            event.preventDefault();
        });
      }

      for(const buttons of this.visually_pleasing_experience_colors){
        document.getElementById(buttons.id).addEventListener("click", (event) => {
            
            this.$store.dispatch('logClicks', { wid:this.wid, label: buttons.title, debug: this.debug});

            event.preventDefault();
        });
      }

    },
    init(){

        const t = this.t;

        // this.visually_pleasing_experience = [
        //     {
        //         id: 'adabundle-action-dark-contrast',
        //         title: 'Dark Contrast',
        //         status: this.widgetOptions.darkContrast
        //     },
        //     {
        //         id: 'adabundle-action-light-contrast',
        //         title: 'Light Contrast',
        //         status: this.widgetOptions.lightContrast
        //     },
        //     {
        //         id: 'adabundle-action-monochrome',
        //         title: 'Monochrome',
        //         status: this.widgetOptions.monochrome
        //     },
        //     {
        //         id: 'adabundle-action-high-contrast',
        //         title: 'High Contrast',
        //         status: this.widgetOptions.highContrast
        //     },
        //     {
        //         id: 'adabundle-action-high-saturation',
        //         title: 'High Saturation',
        //         status: this.widgetOptions.highSaturation
        //     },
        //     {
        //         id: 'adabundle-action-low-saturation',
        //         title: 'Low Saturation',
        //         status: this.widgetOptions.lowSaturation
        //     }
        // ];

        this.visually_pleasing_experience = [
            {
                id: 'adabundle-action-dark-contrast',
                title: t.dark_contrast.text,
                status: this.widgetOptions.darkContrast
            },
            {
                id: 'adabundle-action-light-contrast',
                title: t.light_contrast.text,
                status: this.widgetOptions.lightContrast
            },
            {
                id: 'adabundle-action-monochrome',
                title: t.monochrome.text,
                status: this.widgetOptions.monochrome
            },
            {
                id: 'adabundle-action-high-contrast',
                title: t.high_contrast.text,
                status: this.widgetOptions.highContrast
            },
            {
                id: 'adabundle-action-high-saturation',
                title: t.high_saturation.text,
                status: this.widgetOptions.highSaturation
            },
            {
                id: 'adabundle-action-low-saturation',
                title: t.low_saturation.text,
                status: this.widgetOptions.lowSaturation
            }
        ];

        // this.visually_pleasing_experience_colors = [
        //     {
        //         id: 'adabundle-action-text-colors',
        //         title: 'Adjust Text Colors',
        //         status: this.widgetOptions.textColors
        //     },
        //     {
        //         id: 'adabundle-action-title-colors',
        //         title: 'Adjust Title Colors',
        //         status: this.widgetOptions.titleColors
        //     },
        //     {
        //         id: 'adabundle-action-background-colors',
        //         title: 'Adjust Background Colors',
        //         status: this.widgetOptions.backgroundColors
        //     }
        // ]

        this.visually_pleasing_experience_colors = [
            {
                id: 'adabundle-action-text-colors',
                title: t.adjust_text_color.text,
                status: this.widgetOptions.textColors
            },
            {
                id: 'adabundle-action-title-colors',
                title: t.adjust_title_color.text,
                status: this.widgetOptions.titleColors
            },
            {
                id: 'adabundle-action-background-colors',
                title: t.adjust_background_color.text,
                status: this.widgetOptions.backgroundColors
            }
        ]

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
